<template>
  <div class="footer">
    <div class="content">
      <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
      <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
      <p>批准文号：国新出审[2023]630号<span class="seperator">|</span>出版物号：ISBN 978-7-498-12269-8<span class="seperator">|</span>ICP备案：沪ICP备2021002543号-3A</p>
      <p>
        <span>版权所有：上海雨玩网络科技有限公司</span>
        <span class="seperator">|</span>
        <span class="link" @click="openRegister">用户注册协议</span>
        <span class="seperator">|</span>
        <span class="link" @click="openPrivacy(1)">隐私政策</span>
        <span class="seperator">|</span>
        <span class="link" @click="openPrivacy(2)">儿童隐私政策</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFooter',
  methods: {
    openRegister() {
      window.open('https://sdk.xianyouwan.com/protect/index3.html?body=shyw')
    },
    openPrivacy(type) {
      switch (type) {
        case 1:
          window.open('http://www.yuwanyouxi.com/html/protocol.html')
          break
        case 2:
          window.open('https://sdk.xianyouwan.com/protect/index2.html?body=shyw')
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 27.733333vw;
  background: #2c2320;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    align-items: center;
    padding: 3vw 0;
    width: 80%;
    height: 100%;
    font-size: 2.133333vw;
    font-family: Noto Serif SC;
    color: #fff;
  }

  .seperator {
    margin: 0 1.333333vw;
  }

  .link {
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
